import {uniqueId} from '@yandex-delivery/utils'

export const generateUniqueId = (): number => Number(uniqueId(''))
